export default __webpack_public_path__ + "static/media/page5.92987db9.png";